import {HttpHeaders} from '@angular/common/http';
import {Configuration, EventsResponse, PushSubscriptionServiceInterface, SubscribeResponse, UnsubscribeResponse} from '@gt-api';
import {Observable, of, throwError} from 'rxjs';

const subscribeResponse = {
  code: 200,
  message: 'OK',
  asyncTimeout: 30000
} as SubscribeResponse;

export class PushSubscriptionServiceStub implements PushSubscriptionServiceInterface {
  defaultHeaders: HttpHeaders = new HttpHeaders();
  configuration: Configuration;

  unsubscribe1(): Observable<UnsubscribeResponse> {
    return undefined;
  }

  subscribeEndUser1(): Observable<SubscribeResponse> {
    return of(subscribeResponse);
  }

  subscribeAbsence1(): Observable<SubscribeResponse> {
    return of(subscribeResponse);
  }

  subscribeVirtualNumber1(): Observable<SubscribeResponse> {
    return of(subscribeResponse);
  }

  getEvents1(extraHttpRequestParams?: any): Observable<EventsResponse> {
    return throwError('Throwing error in order to exit the getEvents loop');
  }
}
